import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export function useDisbursementSettings() {
  return useQuery({
    queryKey: ['disbursementSettings'],
    queryFn: async () => {
      const res = await authFetch(`${API_URL}/disbursement-settings/`);
      if (!res.ok) throw new Error('Failed to fetch disbursement settings');
      return res.json();
    },
  });
} 